import moment from 'moment';
import { Activity } from 'src/types/activity';

/**
 *
 * @param tasks
 * @returns an array of tasks that are past due
 */
export function getPastDueTasks(tasks: Activity[]) {
  var now = moment().startOf('day');
  return tasks.filter((task) => {
    var due = moment(task.dueDate).startOf('day');
    return now.isAfter(due);
  });
}

/**
 *
 * @param tasks
 * @returns an array of tasks that are due today
 */
export function getTasksDueToday(tasks: Activity[]) {
  var now = moment().startOf('day');
  return tasks.filter((task) => {
    var due = moment(task.dueDate).startOf('day');
    return now.isSame(due, 'day');
  });
}

/**
 *
 * @param tasks
 * @returns an array of tasks that are due tomorrow or later
 */
export function getUpcomingTasks(tasks: Activity[]) {
  var tomorrow = moment().startOf('day').add(1, 'day');
  return tasks.filter((task) => {
    //start of tomorrow and future
    var due = moment(task.dueDate).startOf('day');
    return tomorrow.isSameOrBefore(due);
  });
}
